export class Comparator {
    static string(stringA: string, stringB: string) {
        stringA = stringA.toLowerCase()
        stringB = stringB.toLowerCase()

        if (stringA > stringB) {
            return 1
        }

        if (stringA < stringB) {
            return -1
        }

        return 0
    }

    static date(dateA: Date, dateB: Date) {
        const timeDiff = dateA.getTime() - dateB.getTime()

        if (timeDiff > 0) {
            return 1
        }

        if (timeDiff < 0) {
            return -1
        }

        return 0
    }
}



// WEBPACK FOOTER //
// ./src/app/core/util/comparator.ts